<template>
  <div
    class="avatar-wrapper"
    :class="[avatarBorderClass, avatarBgClass, avatarSizeClass]"
  >
    <feather-icon
      v-if="avatarIcon"
      :icon="avatarIcon"
      :size="iconSize"
      :stroke="iconStroke"
    />
    <span v-else-if="avatarText" class="font-weight-600">{{ avatarText }}</span>
  </div>
</template>

<script>
export default {
  name: "AtomCustomAvatar",
  props: {
    avatarVariant: {
      type: String,
      required: false,
      default: "light-primary",
    },
    avatarBorderStyle: {
      type: String,
      required: false,
      default: "circle",
    },
    avatarSize: {
      type: String,
      required: false,
      default: "md",
    },
    avatarIcon: {
      type: String,
      required: false,
    },
    avatarText: {
      type: String,
      required: false,
    },
  },

  computed: {
    avatarBorderClass(){
      return `${this.avatarBorderStyle?.toLowerCase()}-avatar`
    },

    avatarBgClass() {
      return `${this.avatarVariant?.toLowerCase()}-bg`
    },

    avatarSizeClass() {
      return `avatar-size-${this.avatarSize?.toLowerCase()}`
    },

    iconStroke() {
      if (!this.avatarVariant?.includes("light-")) return "#ffffff"
      else if (this.avatarVariant === "light-primary") return "#7167e8"
      else if (this.avatarVariant === "light-secondary") return "#83868a"
      else if (this.avatarVariant === "light-success") return "#61c478"
      else if (this.avatarVariant === "light-danger") return "#d95e5a"
      else if (this.avatarVariant === "light-warning") return "#f2a356"
      else if (this.avatarVariant === "light-info") return "#5ecce5"
      else return "#83868a"
    },

    iconSize() {
      if (this.avatarSize?.toLowerCase() === "sm") return "12"
      else if (this.avatarSize?.toLowerCase() === "md") return "16"
      else if (this.avatarSize?.toLowerCase() === "md") return "24"
      else return "16"
    },
  },

  mounted() {},

  methods: {},
}
</script>

<style lang="scss" scoped>
.avatar-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.circle-avatar {
  border-radius: 50%;
}

.rounded-avatar {
  border-radius: 50%;
}

.square-avatar {
  border-radius: 6px;
}

.avatar-size-sm {
  width: 1.5rem;
  height: 1.5rem;
  font-size: 12px;
}

.avatar-size-md {
  width: 2.5rem;
  height: 2.5rem;
  font-size: 14px;
}

.avatar-size-lg {
  width: 3.5rem;
  height: 3.5rem;
  font-size: 24px;
}

.primary-bg {
  background-color: #7167e8;
  color: #ffffff;
}

.light-primary-bg {
  background-color: #eeedfc;
  color: #7167e8;
}

.secondary-bg {
  background-color: #83868a;
  color: #ffffff;
}

.light-secondary-bg {
  background-color: #f0f0f1;
  color: #83868a;
}

.success-bg {
  background-color: #61c478;
  color: #ffffff;
}

.light-success-bg {
  background-color: #ecf8ef;
  color: #61c478;
}

.danger-bg {
  background-color: #d95e5a;
  color: #ffffff;
}

.light-danger-bg {
  background-color: #faebeb;
  color: #d95e5a;
}

.warning-bg {
  background-color: #f2a356;
  color: #ffffff;
}

.light-warning-bg {
  background-color: #fdf4ea;
  color: #f2a356;
}

.info-bg {
  background-color: #5ecce5;
  color: #ffffff;
}

.light-info-bg {
  background-color: #ebf9fc;
  color: #5ecce5;
}

.custom-icon-position {
  margin: 3px 0 0 3px;
}
</style>
